import {AbstractControl} from '@angular/forms';
import {isEmail, isURL} from "validator";

export class CustomValidators {

  static websiteUrl(control: AbstractControl): { [key: string]: any } | null {
    if (control?.value) {
      return isURL(control.value, {require_protocol: false}) ? null : {websiteUrlInvalid: true};
    }
    return null;
  }

  static email(control: AbstractControl): { [key: string]: any } | null {
    if (control?.value) {
      return isEmail(control.value) ? null : {emailFormatInvalid: true};
    }
    return null;
  }

}
